import {fadeIn, fadeOut} from "../helpers/animation";

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const activeClass = 'header--scrollable';

  window.addEventListener('scroll', (e) => {
    if (window.scrollY > 100) {
      header.classList.add(activeClass);
    } else {
      header.classList.remove(activeClass);
    }

    return;
  })
});
